import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import ReactPaginate from "react-paginate";
import Footer from "../common/Footer";
import { TableDataSkeleton } from '../../components/SkeletonLoader';

const UnverifiedUsers = () => {
  const userToken = localStorage.getItem("userToken");
  const [ngos, setNgos] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ngos?.slice(indexOfFirstItem, indexOfLastItem);

  const loadData = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/unverified`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setNgos(response.data.unverifiedUsers);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div style={{ margin: "100px auto", maxWidth: "1200px", padding: "0 20px" }}>
        <h1 id="head_dash" style={{ margin: "30px 0", textAlign: "left" }}>
          Unverified Users
        </h1>

        {loading &&  
          <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
            <TableDataSkeleton/>
          </div>
        }

        <div
          className="shadow-box admin-box"
          style={{ width: "95%", marginTop: "10px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          ></div>
          <hr style={{ marginBottom: "20px" }} />
          <div className="table">
            <table style={{ textAlign: "left" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Name</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Email</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Profile</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>Country</th>
                  <th style={{ textAlign: "left", whiteSpace: "nowrap" }}>CreatedOn</th>
                </tr>
              </thead>
              <tbody>
                {currentItems?.map((ngo, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "left" }}>
                        {ngo.profileType === "ngo" ||
                        ngo.profileType === "impactOrg" ||
                        ngo.profileType === "business"
                          ? ngo.businessName
                          : ngo?.firstName + " " + ngo?.lastName}
                       </td>
                    <td style={{ textAlign: "left" }}>
                      {ngo.email}
                    </td>
                    <td style={{ textAlign: "left" }}>
                    {ngo.profileType}
                    </td>
                    <td style={{ textAlign: "left" }}>
                    {ngo.country}
                    </td>
                    <td style={{ textAlign: "left" }}>
                    {moment(ngo.createdDate).format("DD-MM-YYYY hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(ngos?.length / itemsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UnverifiedUsers;
